<div class="card no-border voffset-20">
    <div class="card-body">
        <div class="row">
            <div
                class="col-sm-4 offset-sm-6 bolded text-align-right"
                [translate]="'PurchaseDetails.tuition'"
            ></div>
            <div class="col-sm-2 main-green bolded text-align-right">
                {{ purchase.netTotalAmount | amount }}
            </div>
        </div>
        @if (purchase.creditPointsDeduction.numberOfDays > 0) {
            <div class="row">
                <div class="col-sm-4 offset-sm-6 bolded text-align-right">
                    <span
                        [translate]="'PurchaseDetails.creditDaysRedemption'"
                    ></span>
                    <span class="main-red">
                        (
                        <span
                            >-{{ purchase.creditPointsDeduction.numberOfDays }}
                        </span>
                        @if (purchase.creditPointsDeduction.numberOfDays == 1) {
                            <span
                                [translate]="'PurchaseDetails.redemptionDay'"
                            ></span>
                        }
                        @if (purchase.creditPointsDeduction.numberOfDays > 1) {
                            <span
                                [translate]="'PurchaseDetails.redemptionDays'"
                            ></span>
                        }
                        ):
                    </span>
                </div>
                <div class="col-sm-2 main-red bolded text-align-right">
                    <span
                        >-{{
                            purchase.creditPointsDeduction.value | amount
                        }}</span
                    >
                </div>
            </div>
        }

        <div class="row">
            <div
                class="col-sm-4 offset-sm-6 bolded text-align-right"
                [translate]="'PurchaseDetails.additionalOptions'"
            ></div>
            <div class="col-sm-2 main-green bolded text-align-right">
                {{ purchase.netOptionsAmount | amount }}
            </div>
        </div>

        @if (purchase.couponDetails && purchase.couponDetails.totalValue > 0) {
            <div class="row">
                <div class="col-sm-4 offset-sm-6 bolded text-align-right">
                    <span [translate]="'PurchaseDetails.couponValue'"></span
                    ><span class="main-red"
                        >({{
                            getCouponDescription(purchase.couponDetails.coupon)
                        }}):</span
                    >
                </div>
                <div class="col-sm-2 main-red bolded text-align-right">
                    -{{ purchase.couponDetails.totalValue | amount }}
                </div>
            </div>
        }

        @if (
            purchase.paymentMethodFee && purchase.paymentMethodFee.amount > 0
        ) {
            <div class="row">
                <div class="col-sm-4 offset-sm-6 bolded text-align-right">
                    {{ purchase.paymentMethodFee.description }}:
                </div>
                <div class="col-sm-2 main-green bolded text-align-right">
                    {{ purchase.paymentMethodFee.netAmount | amount }}
                </div>
            </div>
        }

        @for (item of purchase.taxes; track item) {
            <div class="row">
                <div class="col-sm-4 offset-sm-6 bolded text-align-right">
                    {{
                        "PurchaseDetails.tax"
                            | translate: { taxRate: item.taxRate }
                    }}
                </div>
                <div class="col-sm-2 main-green bolded text-align-right">
                    {{ item.taxValue | amount }}
                </div>
            </div>
        }

        <hr class="offset-sm-8" />
        <div class="row">
            <div
                class="col-sm-4 offset-sm-6 bolded text-align-right"
                [translate]="'PurchaseDetails.toBePaid'"
            ></div>
            <div class="col-sm-2 main-green bolded text-align-right">
                {{ purchase.totalIncludingPaymentMethodFeeAmount | amount }}
            </div>
        </div>
    </div>
</div>
